import { HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";

import { RecaptchaModule } from "ng-recaptcha";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ButtonComponent } from "./components/button/button.component";
import { ResultsComponent } from "./components/results/results.component";
import { HomePageComponent } from "./pages/home-page/home-page.component";
import { ScreeningToolPageComponent } from "./pages/screening-tool-page/screening-tool-page.component";
import { QuestionsService } from "./services/questions.service";
import { ResultsService } from "./services/results.service";

import { AdobeAnalyticsModule } from "@abbvie-epi/common/adobe-analytics/";
import { ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { environment } from "../environments/environment";
import { IsInArrayPipe } from "./common/pipes/is-in-array.pipe";
import { BottomNavigationComponent } from "./components/bottom-navigation/bottom-navigation.component";
import { CollaboratorsPublicationsComponent } from "./components/collaborators-publications/collaborators-publications.component";
import { ConsiderationsLimitationsComponent } from "./components/considerations-limitations/considerations-limitations.component";
import { CustomSelectComponent } from "./components/custom-select/custom-select.component";
import { DevelopingTheToolComponent } from "./components/developing-the-tool/developing-the-tool.component";
import { FeedbackComponent } from "./components/feedback/feedback.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HcpComponent } from "./components/hcp/hcp.component";
import { HeaderComponent } from "./components/header/header.component";
import { IntroductionComponent } from "./components/introduction/introduction.component";
import { LeavingSiteModalComponent } from "./components/leaving-site-modal/leaving-site-modal.component";
import { LoginModalComponent } from "./components/login-modal/login-modal.component";
import { ModalComponent } from "./components/modal/modal.component";
import { NormalLayoutComponent } from "./components/normal-layout/normal-layout.component";
import { ReferencesComponent } from "./components/references/references.component";
import { SentryTestComponent } from "./components/sentry-test/sentry-test.component";
import { StartScreeningComponent } from "./components/start-screening/start-screening.component";
import { Table1Component } from "./components/tables/table1/table1.component";
import { Table2Component } from "./components/tables/table2/table2.component";
import { Table3Component } from "./components/tables/table3/table3.component";
import { Table4Component } from "./components/tables/table4/table4.component";
import { Table5Component } from "./components/tables/table5/table5.component";
import { Table6Component } from "./components/tables/table6/table6.component";
import { VideoPlayerComponent } from "./components/video-player/video-player.component";
import { DevelopmentPageComponent } from "./pages/development-page/development-page.component";
import { FaqsPageComponent } from "./pages/faqs-page/faqs-page.component";
import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";
import { ScreeningToolLandingPageComponent } from "./pages/screening-tool-landing-page/screening-tool-landing-page.component";
import { WhatIsEpiPageComponent } from "./pages/what-is-epi-page/what-is-epi-page.component";
import { initializeAppFactory } from "./providers/initialize-app.factory";
import { ConfigService } from "./services/config.service";

@NgModule({
    declarations: [
        AppComponent,
        HomePageComponent,
        ScreeningToolPageComponent,
        ButtonComponent,
        ResultsComponent,
        LoginModalComponent,
        HeaderComponent,
        FooterComponent,
        HcpComponent,
        NormalLayoutComponent,
        ScreeningToolLandingPageComponent,
        StartScreeningComponent,
        FeedbackComponent,
        ReferencesComponent,
        BottomNavigationComponent,
        IntroductionComponent,
        FaqsPageComponent,
        SentryTestComponent,
        FaqsPageComponent,
        ModalComponent,
        VideoPlayerComponent,
        DevelopmentPageComponent,
        DevelopingTheToolComponent,
        ConsiderationsLimitationsComponent,
        CustomSelectComponent,
        CollaboratorsPublicationsComponent,
        PageNotFoundComponent,
        LeavingSiteModalComponent,
        WhatIsEpiPageComponent,
        Table1Component,
        Table2Component,
        Table3Component,
        Table4Component,
        Table5Component,
        Table6Component,
        IsInArrayPipe
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        FormsModule,
        RecaptchaModule,
        AdobeAnalyticsModule.forRoot(environment.adobeAnalyticsConfig)
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeAppFactory,
            deps: [ConfigService, Sentry.TraceService],
            multi: true
        },
        QuestionsService,
        ResultsService,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
                logErrors: environment.environmentName === "development"
            })
        },
        {
            provide: Sentry.TraceService,
            deps: [Router]
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
